export const ProvisionInvoiceState = Object.freeze({
    Unknown: 0,
    Unprocessed: 1,
    NotToBeInvoiced: 2,
    Accepted: 3,
    Denied: 4,
    Waiting: 5,
    Completed: 6,
    FetchedToInvoicing: 100,
    AddedToInvoice: 101
});

export const ProvisionInvoiceStateMixin = {
    data() {
        return {
            provisionInvoiceStates: ProvisionInvoiceState
        };
    },
    methods: {
        provisionInvoiceStateToText(value) {
            const translations = {
                [ProvisionInvoiceState.Unknown]: "Unknown",
                [ProvisionInvoiceState.Unprocessed]: "Unprocessed",
                [ProvisionInvoiceState.NotToBeInvoiced]: "Not to Be Invoiced",
                [ProvisionInvoiceState.Accepted]: "Accepted",
                [ProvisionInvoiceState.Denied]: "Denied",
                [ProvisionInvoiceState.Waiting]: "Waiting",
                [ProvisionInvoiceState.Completed]: "Completed",
                [ProvisionInvoiceState.FetchedToInvoicing]: "Fetched to Invoicing",
                [ProvisionInvoiceState.AddedToInvoice]: "Added to Invoice"
            };
            return translations[value] || "Unknown";
        }
    }
};
